export default __webpack_public_path__ + "static/media/JAJ-photo.57b5bb54.webp";